import React, { FC } from 'react';

import Markdown, { Components } from 'react-markdown';

type BetterMarkdownProps = {
  children: string;
  components?: Components;
};

export const BetterMarkdown: FC<BetterMarkdownProps> = ({ children, components }) => {

  return (
    <Markdown components={components ?? {}}>
      {children}
    </Markdown>
  );

};
